import {BookingflowStateMachine, NotAvailableState, State} from "../..";
import {errActions, errorStateActions, ErrorStateActions} from "./errorState.types";

const ERROR_STATE = "ERROR_STATE";

export default class ErrorState extends State<ErrorStateActions, typeof ERROR_STATE> {
  public readonly type = ERROR_STATE;

  constructor(bookingflowStateMachine: BookingflowStateMachine) {
    super(bookingflowStateMachine);
  }

  public doAction(action: ErrorStateActions): this | NotAvailableState {
    switch (action.type) {
      case "CHOOSE_NO_AVAILABLE":
        return new NotAvailableState(this.bookingflowStateMachine);
      default:
        return this;
    }
  }
  public getActions = (): errActions[] => errorStateActions.filter((action) => new action(this).isDoable());
  public getData() {
    return;
  }
  public unset(action: ErrorStateActions): void {
    return;
  }
}
